import { Container, Title, Text, Button } from '@mantine/core';
import classes from './css/HeroImageRight.module.css';

export function HeroImageRight() {
  return (
    <div className={classes.root}>
      <Container size="lg">
        <div className={classes.inner}>
          <div className={classes.content}>
            <Title className={classes.title}>
              <Text
                component="span"
                inherit
                variant="gradient"
                gradient={{ from: 'violet', to: 'red', deg: 131 }}
              >
                Hello!
              </Text>{" "}Welcome to my website
              <Text
                component="span"
                inherit
                variant="gradient"
                gradient={{ from: 'violet', to: 'red', deg: 131 }}
              >
               ...
              </Text>
            </Title>

            <Text className={classes.description} mt={30} style={{color: "white", fontSize: "20px"}}>
              I hope you stick around for a while
            </Text>

            {/* <Button
              variant="gradient"
              gradient={{ from: 'pink', to: 'yellow' }}
              size="xl"
              className={classes.control}
              mt={40}
            >
              Get started
            </Button> */}
          </div>
        </div>
      </Container>
    </div>
  );
}